import React from "react";
import {Button, Pane, Tooltip} from "evergreen-ui";

export default function SmartButton({
    disabledTooltip,
    buttonText,
    isDisabled,
    isPrimary,
    onClickAction,
    iconAfter
}) {
    return (
        isDisabled ?
            <Tooltip
                content={disabledTooltip}
            >
                <Pane display={"inline"}>
                    <Button
                        iconAfter={iconAfter === undefined ? "" : iconAfter}
                        disabled={true}
                    >
                        {buttonText}
                    </Button>
                </Pane>
            </Tooltip>
        :
            <Button
                iconAfter={iconAfter === undefined ? "" : iconAfter}
                appearance={isPrimary ? "primary" : "default"}
                onClick={onClickAction}
                disabled={false}
            >
                {buttonText}
            </Button>
    )

}